export function DeleteIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 4.5H3.33333H14" stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M12.6668 4.49992V13.8333C12.6668 14.1869 12.5264 14.526 12.2763 14.7761C12.0263 15.0261 11.6871 15.1666 11.3335 15.1666H4.66683C4.31321 15.1666 3.97407 15.0261 3.72402 14.7761C3.47397 14.526 3.3335 14.1869 3.3335 13.8333V4.49992M5.3335 4.49992V3.16659C5.3335 2.81296 5.47397 2.47382 5.72402 2.22378C5.97407 1.97373 6.31321 1.83325 6.66683 1.83325H9.3335C9.68712 1.83325 10.0263 1.97373 10.2763 2.22378C10.5264 2.47382 10.6668 2.81296 10.6668 3.16659V4.49992"
        stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.6665 7.83325V11.8333" stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M9.3335 7.83325V11.8333" stroke="#9B9B9B" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
  )
}